import { Atividade } from '../models/atividade';
import { Empresa } from '../models/scope';

/**
 * `Empresa.statusFechamento`/`percentualConcluido` não existem no cadastro real da plataforma —
 * o adapter (maestroService.adaptEmpresa) não tem como preenchê-los com dado de verdade. Este
 * cálculo deriva um status real a partir das atividades da empresa no ciclo ativo, contra o mesmo
 * `progressoEsperado` que já governa o restante do Cockpit — usado tanto pelo card "Saúde do
 * Fechamento" quanto pelo indicador "Empresas em risco" do topo, pra não duplicar a lógica com
 * critérios diferentes em cada lugar.
 */
export function empresaEstaEmRisco(empresa: Empresa, atividades: Atividade[], progressoEsperado: number): boolean {
  const daEmpresa = atividades.filter(a => a.empresaId === empresa.id);
  if (daEmpresa.length === 0) return false;

  const concluidas = daEmpresa.filter(a => a.status === 'CONCLUIDA' || a.status === 'CANCELADA').length;
  const percentualConcluido = (concluidas / daEmpresa.length) * 100;
  const temAtividadeAtrasada = daEmpresa.some(a => a.status === 'ATRASADA');
  const desvio = percentualConcluido - progressoEsperado;

  return temAtividadeAtrasada || desvio < -20;
}
